import React, { forwardRef } from "react";
import FormControlMessage from "../FormControlMessage";
import FormGroup from "../FormGroup";
import Label from "../Label";
import "./Textarea.css";
import withTheme from "../../hocs/withTheme";

/** Always use labels on text areas and don’t depend on the placeholder text.
 * If there is more information for the text area needed make
 * use of a paragraph on top or use an info box. */

function Textarea(props) {
    const {
        label = null,
        labelInfobox = false,
        disabled = false,
        required = false,
        error = null,
        defaultValue = null,
        children = null,
        helpText = null,
        id = null,
        innerRef: ref = null,
        ...rest
    } = props;

    return (
        <FormGroup disabled={disabled} error={error}>
            {label && (
                <Label
                    htmlFor={id || label}
                    label={label}
                    labelInfobox={labelInfobox}
                    required={required}
                    helpText={helpText}
                />
            )}
            <textarea
                {...rest}
                id={id || label}
                ref={ref}
                className="Textarea"
                disabled={disabled}
                required={required}
            />

            {error && <FormControlMessage>{error}</FormControlMessage>}

            {children && <p>{children}</p>}
        </FormGroup>
    );
}


export default forwardRef((props, ref) =>
    withTheme(Textarea)({ ...props, innerRef: ref })
);
